import Header from '@/components/header'
import { useAppSelector } from '@/hooks'
import { Layout } from '@/pages/customer/layout'

import { LogoIcon, LogoImage } from '@/assets/icons'

export const BookingSuccess = () => {
	const auth = useAppSelector(state => state.auth)
	return (
		<>
			{auth?.id ? (
				<Layout title="Regal Mieten">
					<div className="mt-2 lg:mt-3 grow container mx-auto rounded-xl lg:rounded-[16px] px-4 max-lg:pb-3 max-lg:pt-8 lg:px-6 lg:py-10 bg-white flex flex-col">
						<div className="grow self-stretch flex items-center mt-10 flex-col">
							<LogoIcon className="shrink-0 max-lg:hidden lg:size-44" />
							<img src={LogoImage} className="size-32 lg:hidden" />
							<p className="mt-4 lg:text-lg font-medium">Platz schaffen und Gutes tun</p>
							<div className="flex flex-col items-center gap-1 my-10">
								<p className="text-lg lg:text-2xl text-center font-bold">
									Vielen Dank für deine Buchung!
								</p>
								<p className="lg:text-lg text-center">
									Weitere Details zu deiner Buchung findest du in deiner Bestellbestätigung.
								</p>
							</div>
							<p className="text-center lg:text-lg">Wir freuen uns auch dich!</p>
						</div>
					</div>
				</Layout>
			) : (
				<div className="mx-auto">
					<Header currentPage="regalMieten" />
					<div className="mt-2 lg:mt-3 grow container mx-auto rounded-xl lg:rounded-[16px] px-4 max-lg:pb-3 max-lg:pt-8 lg:px-6 lg:py-10 bg-white flex flex-col">
						<div className="grow self-stretch flex items-center mt-10 flex-col">
							<LogoIcon className="shrink-0 max-lg:hidden lg:size-44" />
							<img src={LogoImage} className="size-32 lg:hidden" />
							<p className="mt-4 lg:text-lg font-medium">Platz schaffen und Gutes tun</p>
							<div className="flex flex-col items-center gap-1 my-10">
								<p className="text-lg lg:text-2xl text-center font-bold">
									Vielen Dank für deine Buchung!
								</p>
								<p className="lg:text-lg text-center">
									Weitere Details zu deiner Buchung findest du in deiner Bestellbestätigung.
								</p>
							</div>
							<p className="text-center lg:text-lg">Wir freuen uns auch dich!</p>
						</div>
					</div>
				</div>
			)}
		</>
	)
}
